"use client";
import { MenuBar } from "@/components/menu/MenuBar";
import { useSlugGameSystem } from "@/hooks";
import { Tab, Tabs } from "@mui/material";
import Link from "next/link";
import { usePathname } from "next/navigation";

export default function QuestMenuBar() {
  const gameSystem = useSlugGameSystem();
  const pathname = usePathname();

  const basePath = `/quest/${gameSystem?.slug}`;
  const value = (() => {
    if (pathname === basePath) return 0;
    else if (pathname.startsWith(`${basePath}/heroes`)) return 1;
    else if (pathname.startsWith(`${basePath}/collections`)) return 2;
    return -1;
  })();

  return (
    <MenuBar
      title={gameSystem?.name}
      tabBar={
        value > -1 && (
          <Tabs
            value={value}
            centered
            variant="fullWidth"
            textColor="inherit"
            indicatorColor={"common.white" as any}
          >
            <Tab
              sx={{ fontWeight: 600, fontSize: "1rem" }}
              label={"Play"}
              component={Link}
              href={`${basePath}`}
            />
            <Tab sx={{ fontWeight: 600 }} label={"Heroes"} component={Link} href={`${basePath}/heroes`} />
            <Tab
              sx={{ fontWeight: 600 }}
              label={"Collections"}
              component={Link}
              href={`${basePath}/collections`}
            />
          </Tabs>
        )
      }
    />
  );
}
